module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-10.02f0b0a4.svg";